import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { ArrowsMain, TestQuate } from "../../../app-constants";

function Imprint({ data }) {
  return (
    <>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekrevol_project_item"
          >
            <div
              className="pizza_project"
              style={{ background: "rgb(255, 255, 255)" }}
            >
              <Row>
                <Col xs={12} md={8} lg={6} xl={6} xxl={6}>
                  <div className="project_info">
                    <div className="logo_project">
                      <StaticImage
                        src="../../images/imprint/logo.webp"
                        alt="tekrevol_Casestudy"
                        className="img-fluid"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={175}
                        height={90}
                      />
                    </div>
                    <div className="framework_project">
                      <ul style={{ color: "rgb(218 32 36)" }}>
                        <li>IOS App</li>
                        <li>Android App</li>
                        <li>Web App</li>
                      </ul>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={4} lg={6} xl={6} xxl={6}>
                  <div
                    className="project_statistics"
                    style={{ color: "rgb(218 32 36)" }}
                  ></div>
                </Col>
                <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
                  <div
                    className="project_title"
                    style={{ color: "rgb(40, 35, 29)" }}
                  >
                    <h2>The Idea Behind Soundly</h2>
                    <div className="project_details">
                      <p>
                        Soundly has revolutionized the way people experience
                        music. Designed to enable music lovers to stream
                        millions of songs from new artists through the app, the
                        Soundly app lets you save songs for later by creating
                        countless playlists, uploading your own tracks,
                        supporting your favorite artists, and experiencing a
                        next-gen technology and music collaboration in perfect
                        harmony.
                      </p>
                      <p>
                        The idea was based not only on building a revolutionary
                        entertainment app but also on ensuring predictive,
                        user-friendly, and seamless navigation and controls that
                        would let the users instantly tap their way to their
                        favorite songs coming directly from new artists or
                        upload their songs.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={12} lg={6} xl={7} xxl={7}>
                  <div className="img_prev">
                    <div className="case_item">
                      <StaticImage
                        src="../../images/imprint/main_image.webp"
                        alt="tekrevol_Casestudy"
                        className="img-fluid"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={1035}
                        height={842}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          <Col
            xs={12}
            md={9}
            lg={7}
            xl={6}
            xxl={6}
            className="m-auto tekrevol_project_review"
          >
            <div className="project_review">
              <p>
                “We truly appreciate how much Tekrevol cares about our project,
                from the beginning point to the deployment, they delivered
                everything efficiently." {TestQuate}
              </p>
              <div className="review_info">
                <div className="preson">
                  <StaticImage
                    src="../../images/imprint/client.webp"
                    alt="tekrevol_Casestudy"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={70}
                    height={70}
                  />
                </div>
                <div className="preson_info">
                  <h6>Ethan Dobbins</h6>
                  <div className="designation">Soundly, CEO</div>
                  <div className="project_link">
                    <Link
                      to="/case-studies/soundly"
                      aria-label="TekRevol Soundly"
                    >
                      Full Case Study {ArrowsMain}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Imprint;
